import { CompareFieldGroupWrapper } from '@modules/quantify/components/CompareFieldGroupWrapper';
import {
  DEFAULT_COMPARE_DURATION_A_NAME,
  DEFAULT_COMPARE_DURATION_B_NAME,
} from '@modules/quantify/constants';
import { useGetFormattedDurationFieldLabels } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Box, Stack, Typography } from '@mui/material';

export const CompareByTimePreview = () => {
  const { durationLabel, compareDurationLabel } =
    useGetFormattedDurationFieldLabels();

  const compareDurationAName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.baseQueryName || DEFAULT_COMPARE_DURATION_A_NAME,
  );
  const compareDurationBName = useQuantifyStore(
    ({ query }) =>
      query.compareMetadata?.deltaQueryName || DEFAULT_COMPARE_DURATION_B_NAME,
  );

  if (!compareDurationLabel.primary) {
    return null;
  }

  return (
    <Stack spacing={0.5}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="subtitle1">Compare by Time</Typography>
        <Typography variant="caption" color="text.secondary">
          (A - B)
        </Typography>
      </Stack>
      <CompareFieldGroupWrapper
        relationIndicatorSx={{
          mt: 0.2,
        }}
        fieldA={
          <Stack spacing={1} pb={2}>
            <Box>
              <Typography variant="body2">{compareDurationAName}:</Typography>
              <Typography variant="body2" color="primary">
                {durationLabel.primary}
              </Typography>
              {durationLabel.secondary ? (
                <Typography variant="caption">
                  {durationLabel.secondary}
                </Typography>
              ) : null}
            </Box>
          </Stack>
        }
        fieldB={
          <Stack spacing={1}>
            <Box>
              <Typography variant="body2">{compareDurationBName}:</Typography>
              <Typography variant="body2" color="primary">
                {compareDurationLabel.primary}
              </Typography>
              {compareDurationLabel.secondary ? (
                <Typography variant="caption">
                  {compareDurationLabel.secondary}
                </Typography>
              ) : null}
            </Box>
          </Stack>
        }
      />
    </Stack>
  );
};
